
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, Dialog, DialogActions, DialogContent, FormControl, TextField, FormLabel, InputAdornment, OutlinedInput, CircularProgress, InputLabel, MenuItem, Select, Paper, InputBase, ButtonGroup, FormGroup, FormControlLabel, Chip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SearchIcon from "@mui/icons-material/Search";
import DevicesIcon from '@mui/icons-material/Devices';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";

import { ActualizarUsuario, AgregarUsuario, BuscarUsuarioRH, Usuarios } from "../../connections/admin/UsuarioConnection";
import { ObtenerTipoUsuarios } from "../../connections/catalogos/TipoUsuarioConnection";
import { ObtenerPuestos } from "../../connections/catalogos/PuestoConnection";
import { ObtenerAutoridades } from "../../connections/catalogos/AutoridadConnection";

import { UsuarioProps } from "../../interfaces/admin/UsuarioInterface";
import { TipoUsuarioProps } from "../../interfaces/catalogos/TipoUsuarioInterface";
import { AutoridadProps } from "../../interfaces/catalogos/AutoridadInterface";
import { PuestoProps } from "../../interfaces/catalogos/PuestoInterface";

type ActionType = 'Nuevo' | 'Buscar';

export const UsuariosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState( false );
    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    const [loadingBuscar, setLoadingBuscar] = useState( false );

    const [idUsuario, setIdUsuario] = useState( 0 );
    const [usuarios, setUsuarios] = useState<UsuarioProps[]>( [] );

    const [nombre, setNombre] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [contrasena, setContrasena] = useState( '' );
    const [curp, setCurp] = useState( '' );
    const [acceso, setAcceso] = useState( false );
    const [restablecerContrasena, setRestablecerContrasena] = useState( false );

    const [tipousuario, setTipousuario] = useState( 0 );
    const [tipousuarioArray, setTipousuarioArray] = useState<TipoUsuarioProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [puesto, setPuesto] = useState( 0 );
    const [puestoArray, setPuestoArray] = useState<PuestoProps[]>( [] );

    const [curpBuscar, setCurpBuscar] = useState( '' );

    const [action, setAction] = useState<ActionType>( 'Buscar' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( usuarios, ( item, filtro ) => {

        const nombreCompleto = `${ item.nombre } ${ item.apellido1 } ${ item.apellido2 ?? '' }`.toLowerCase();

        return nombreCompleto.includes( filtro.toLowerCase() );
    });

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const usuarioSelected = usuarios.find( ( elem ) => elem.idUsuario === id );

        if( usuarioSelected ){

            const usuarioUpdate: UsuarioProps = {
                idUsuario: id,
                curp: usuarioSelected.curp,
                nombre: usuarioSelected.nombre,               
                apellido1: usuarioSelected.apellido1, 
                apellido2: usuarioSelected.apellido2, 
                correoElectronico: usuarioSelected.correoElectronico, 
                contrasena: usuarioSelected.contrasena, 
                activo: checked ,
                idEstatus: checked ? 1 : 2,
                idTipoUsuario: usuarioSelected.idTipoUsuario,
                restablecerContrasena: usuarioSelected.restablecerContrasena,
                acceso: usuarioSelected.acceso,                 
                idAutoridad: usuarioSelected.idAutoridad,
                idPuesto: usuarioSelected.idPuesto,              
            };    

            await ActualizarUsuario( usuarioUpdate ).then( resp => {
                
                if( resp.idUsuario ){

                    var newArray = usuarios.map( ( elem ) => {

                    if( elem.idUsuario === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setUsuarios( newArray );
                    
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));   

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idUsuario !== 0 ){

            const usuarioSelected = usuarios.find( ( elem ) => elem.idUsuario === idUsuario );

            if( usuarioSelected ){

                setLoading( true );

                const usuarioUpdate: UsuarioProps = {
                    idUsuario: idUsuario,
                    nombre,               
                    apellido1,
                    apellido2,
                    correoElectronico,
                    contrasena,
                    activo: usuarioSelected.activo,
                    idEstatus: usuarioSelected.activo ? 1 : 2 ,
                    idTipoUsuario: tipousuario,
                    idAutoridad: autoridad,
                    idPuesto: puesto,
                    curp,        
                    acceso,        
                    restablecerContrasena,    
                };    
    
                await ActualizarUsuario( usuarioUpdate ).then( resp => {
                    
                    const { success, message, idUsuario } = resp;

                    if( success ){

                        if( idUsuario ){

                            setTimeout(() => {
                                
                                var newArray = usuarios.map( ( elem ) => {
            
                                    if( elem.idUsuario === idUsuario ){
                
                                        return resp
                                    }
                            
                                    return elem;
                                });
                        
                                setUsuarios( newArray );
                                setOpenModal( false );
                                setShowPassword( false );
                                setLoading( false );
                                
                                dispatch( openSnackbar({ message: message, variant: 'success' }));   
                                
                            }, 700);
        
                        }  
                    }
                    else {
                        
                        dispatch( openSnackbar({ message: message, variant: 'error' }));   
                        setLoading( false );

                    }                      
        
                });

            }       

        }
        else {

            const usuarioAdd: UsuarioProps = {
                idUsuario: 0,
                nombre,               
                apellido1,
                apellido2,
                correoElectronico,
                contrasena,
                activo: true,
                idEstatus: 1,
                idTipoUsuario: tipousuario,
                curp: curp,
                idAutoridad: autoridad,
                idPuesto: puesto,
                acceso,
                restablecerContrasena,  
            };

            setLoading( true );

            await AgregarUsuario( usuarioAdd ).then( resp => {

                const { success, message, idUsuario } = resp;

                if( success ){

                    if( idUsuario ){                
                
                        setTimeout(() => {
                            
                            setUsuarios([ ...usuarios, resp ]);
                            setOpenModal( false );
                            setShowPassword( false );
                            setLoading( false );

                        }, 700);

                    }    
                }
                else {       
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    setLoading( false );

                }  
    
            });

        }

    }

    const handleClose = () => {

        setIdUsuario( 0 );
        setCurpBuscar( '' );
        setCurp('');
        setNombre( '' );
        setApellido1( '' );
        setApellido2( '' )
        setCorreoElectronico( '' )
        setContrasena( '' );
        setCurp( '' );
        setTipousuario( 0 );
        setAutoridad(0)
        setPuesto(0)
        setAcceso(false);
        setRestablecerContrasena(false);

        setShowPassword( false );

    }

    const handleBuscarUsuario = async () => {

        if( curpBuscar === '' ){
            return false;
        }        

        setLoadingBuscar( true );

        await BuscarUsuarioRH( curpBuscar ).then( resp => {           

            const { success, nombres, apellido_Primero, apellido_Segundo, email, curp } = resp;

            if( success ){                        
                
                setTimeout(() => {

                    setCurp( curp ?? '' );
                    setNombre( nombres ?? '' );
                    setApellido1( apellido_Primero ?? '' );
                    setApellido2( apellido_Segundo ?? '' );
                    setCorreoElectronico( email ?? '' );
            
                    setCurpBuscar('');

                    setLoadingBuscar( false );

                }, 100);
            }
            else {                        

                setCurp( '' );
                setNombre( '' );
                setApellido1( '' );
                setApellido2( '' );
                setCorreoElectronico( '' );
                
                setLoadingBuscar( false );
                
                dispatch( openSnackbar({ message: `No se encontro la persona con el CURP: ${ curpBuscar }`, variant: 'error' }));   
            }    

        });
        
    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setUsuarios( [] );

            await Usuarios().then( resp => {

                setTimeout(() => {
                    
                    setUsuarios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    useEffect(() => {
      
        async function obtener(){

            await ObtenerTipoUsuarios().then( resp => {

                setTimeout(() => {
                    
                    setTipousuarioArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    useEffect(() => {
      
        async function obtener(){

            await ObtenerPuestos().then( resp => {

                setTimeout(() => {
                    
                    setPuestoArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])  

    useEffect(() => {
      
        async function obtener(){

            await ObtenerAutoridades().then( resp => {

                setTimeout(() => {
                    
                    setAutoridadArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    return (
        
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Usuarios' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button 
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        onClick={ () => {
                            handleClose();
                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button>

                </Grid>

                <Grid size={{ xs: 12 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por nombre del usuario"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}> Nombre completo </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Correo electrónico </TableCell>   
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> Tipo de usuario </TableCell>  
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}> Puesto </TableCell>  
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%' }}> Acceso </TableCell>  
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idUsuario, nombre, apellido1, apellido2, correoElectronico, contrasena, activo, idTipoUsuario, tipoUsuario, autoridad, puesto , curp ,idAutoridad, idPuesto, acceso, restablecerContrasena }, index ) => (

                                <TableRow key={ index } >
                                
                                    <TableCell sx={{ fontWeight: 'bold' }}>

                                        <Chip                                         
                                            label={ idUsuario }
                                            color={ activo ? 'primary' : 'error' }
                                        />

                                    </TableCell>

                                    <TableCell>
                                        <Typography fontSize={14} fontWeight={'bold'}>{ nombre.toUpperCase() } { apellido1.toUpperCase() } { apellido2?.toUpperCase() }</Typography>
                                        <Typography fontSize={12} mt={1}>{ autoridad }</Typography>
                                    </TableCell>    

                                    <TableCell>
                                        { correoElectronico }
                                    </TableCell>      

                                    <TableCell>
                                        { tipoUsuario }
                                    </TableCell>        

                                    <TableCell>
                                        { puesto }
                                    </TableCell>          

                                    <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>

                                        { acceso && <DevicesIcon /> }

                                    </TableCell>                                        
                                                  
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idUsuario ) }
                                        />                                            
                                  
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdUsuario( idUsuario );
                                                    setNombre( nombre );
                                                    setApellido1( apellido1 );
                                                    setApellido2( apellido2  ?? "")
                                                    setCorreoElectronico( correoElectronico )
                                                    setContrasena( contrasena );
                                                    setTipousuario( idTipoUsuario );
                                                    setCurp(curp ?? "");
                                                    setPuesto(idPuesto ?? 0);
                                                    setAutoridad(idAutoridad ?? 0);
                                                    setAcceso( acceso ?? false );
                                                    setRestablecerContrasena( restablecerContrasena ?? false );

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" fontWeight={'bold'}> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }
                        
                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>

                            }

                    </TableFooter>
                    
                </Table>

            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>      

                    <Grid container spacing={1}>

                        {
                            idUsuario === 0
                            &&
                                <Grid size={12} textAlign={'center'}>

                                    <ButtonGroup
                                        disableElevation
                                        variant="text"
                                        aria-label="Disabled button group"
                                    >
                                        <Button variant={ action === 'Buscar' ? "contained" : "text" } onClick={ () => setAction( 'Buscar' ) }>
                                            Buscar usuario en RRHH
                                        </Button>
                                        <Button variant={ action === 'Nuevo' ? "contained" : "text" } onClick={ () => setAction( 'Nuevo' ) }>
                                            Nuevo usuario
                                        </Button>
                                    </ButtonGroup>

                                </Grid>
                        }

                        {
                            ( action === 'Buscar' && idUsuario === 0 )
                            &&     
                                <Grid size={12} mt={1}> 

                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
                                    >
                                    
                                        <InputBase
                                            sx={{ ml: 1, flex: 1, py: 1 }}
                                            placeholder="Buscar usuario"
                                            inputProps={{ 'aria-label': 'Buscar usuario' }}
                                            value={ curpBuscar }
                                            onChange={ ( e ) => setCurpBuscar( e.target.value.toUpperCase() ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={{ borderRadius: 10, mr: 1 }} 
                                            disabled={ curpBuscar.length < 18 }
                                            loading={ loadingBuscar }
                                            onClick={ handleBuscarUsuario }
                                        >
                                            <SearchIcon />
                                        </Button>      

                                    </Paper>   

                                </Grid>   
                        }

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>CURP</FormLabel>
                                <TextField
                                    placeholder="XXXX000000XXXXXX00"
                                    autoComplete="off"                             
                                    variant="outlined"       
                                    value={ curp }           
                                    onChange={ (e) => setCurp( e.target.value ) }         
                                    disabled={ action === 'Buscar' && idUsuario === 0 }
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Nombre(s)</FormLabel>
                                <TextField
                                    placeholder="Juan"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ nombre }           
                                    onChange={ (e) => setNombre( e.target.value ) }
                                    disabled={ action === 'Buscar' && idUsuario === 0 }
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 1</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"        
                                    value={ apellido1 }           
                                    onChange={ (e) => setApellido1( e.target.value ) }  
                                    disabled={ action === 'Buscar' && idUsuario === 0 }        
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 2</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ apellido2 }           
                                    onChange={ (e) => setApellido2( e.target.value ) }      
                                    disabled={ action === 'Buscar' && idUsuario === 0 }    
                                />

                            </FormControl>

                        </Grid>                       

                        <Grid size={{ xs: 12, md: idUsuario !== 0 ? 8 : 12 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Correo electrónico</FormLabel>
                                <TextField
                                    type="email"
                                    placeholder="persona@pjecz.gob.mx"
                                    autoComplete="off"                             
                                    variant="outlined"       
                                    value={ correoElectronico }           
                                    onChange={ (e) => setCorreoElectronico( e.target.value ) }      
                                />

                            </FormControl>

                        </Grid>
                        
                        {
                            idUsuario !== 0
                            &&
                                <Grid size={{ xs: 12, md: 4 }}>

                                    <FormControl sx={{ mt: 2 }} required fullWidth>

                                        <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1 }}>Contraseña</FormLabel>
                                        <OutlinedInput
                                            placeholder="****************"                                
                                            autoComplete="current-password"  
                                            type={ showPassword ? 'text' : 'password' }
                                            value={ contrasena }           
                                            onChange={ (e) => setContrasena( e.target.value ) }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        edge="end"
                                                        size='small'
                                                        aria-label={ showPassword ? 'hide the password' : 'display the password' }                                        
                                                        onClick={ () => setShowPassword( ( show ) => !show ) }
                                                    >
                                                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />

                                    </FormControl>

                                </Grid>
                        }       

                        {
                            <Grid size={{ xs: 12, md: 12 }}>

                                <FormControl sx={{ mt: 3 }} required fullWidth>
                                    
                                    <InputLabel>Tipo de usuario</InputLabel>
                                
                                    <Select                                                                          
                                        label="Tipo de usuario"
                                        value={ tipousuario }
                                        onChange={ ( e ) => { setTipousuario( parseInt( e.target.value.toString() ) ); setPuesto(0); setAutoridad(0); } }
                                    >
                                        <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                        {
                                            tipousuarioArray.map( ( e ) => (
                                                <MenuItem key={ e.idTipoUsuario } value={ e.idTipoUsuario }>{ e.descripcion }</MenuItem>                                                        
                                            ))
                                        }      
                                    </Select>

                                </FormControl>

                            </Grid>
                        }            

                        {
                            ( tipousuario !== 0 && tipousuario !== 1 )
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl sx={{ mt: 3 }} required fullWidth>
                                        
                                        <InputLabel>Puesto</InputLabel>
                                    
                                        <Select                                       
                                            label="Puesto"
                                            value={ puesto }
                                            onChange={ ( e ) => { setPuesto( parseInt( e.target.value.toString() ) ); } }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                            {
                                                puestoArray.map( ( e ) => (
                                                    <MenuItem key={ e.idPuesto } value={ e.idPuesto }>{ e.descripcion }</MenuItem>                                                        
                                                ))
                                            }    
                                        </Select>

                                    </FormControl>

                                </Grid>
                        }                 

                        {
                            ( tipousuario !== 0 && tipousuario !== 1 )
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl sx={{ mt: 3 }} required fullWidth>
                                        
                                        <InputLabel>Autoridad</InputLabel>
                                    
                                        <Select                                                                         
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ ( e ) => { setAutoridad( parseInt( e.target.value.toString() ) ); } }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                            {
                                                autoridadArray.map( ( e ) => (
                                                    <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>                                                        
                                                ))
                                            }    
                                        </Select>

                                    </FormControl>

                                </Grid>
                        }   

                        <Grid size={{ xs: 12, md: 8 }} mt={2}>

                            <FormControl>

                                <FormLabel>Permitir acceso al sistema de audiencias</FormLabel>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Switch 
                                
                                                checked={ acceso } 
                                                onChange={ ( e ) => setAcceso( e.target.checked ) }
                                            /> 
                                        }
                                        label=""
                                    />
                                </FormGroup>

                            </FormControl>
                                
                        </Grid> 

                        <Grid size={{ xs: 12, md: 4 }} mt={2}>

                            <FormControl>

                                <FormLabel>Restablecer contraseña</FormLabel>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Switch 
                                
                                                checked={ restablecerContrasena } 
                                                onChange={ ( e ) => setRestablecerContrasena( e.target.checked ) }
                                            /> 
                                        }
                                        label=""
                                    />
                                </FormGroup>

                            </FormControl>
                                
                        </Grid>     
                        
                    </Grid>     

                </DialogContent>

                <DialogActions>

                    <Button 
                        color="secondary"
                        disabled={ loading } 
                        onClick={ () => { setOpenModal( false ); handleClose(); } }
                    > 
                        Cancelar 
                    </Button>

                    <Button 
                        loading={ loading } 
                        disabled={ 
                            tipousuario === 1
                            ?
                                idUsuario !== 0
                                ?
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' 
                                : 
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === ''
                            :
                                idUsuario !== 0
                                ?
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' || puesto === 0 || autoridad === 0
                                : 
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || puesto === 0 || autoridad === 0
                        } 
                        variant='contained' 
                        onClick={ handleGuardar }
                    > 
                        Guardar 
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
        
    )
}
